import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CacheService {
  private previousPath = '';
  private currentPath = '';
  private readonly none = 'none';
  private state: { [key: string]: any } = {};

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.previousPath = this.currentPath;
          this.currentPath = event.url.split('?')[0];
          console.log('previous path', this.previousPath);
          console.log('current path', this.currentPath);
        }
      });
  }

  /**
   * 暫存資料
   * ex: 如果設定PreviousPath，則呼叫 takeMatchPreviousPath取值
   * ex: 如果未設定PreviousPath, 則呼叫 takeNoneCondition取值
   * @param date 資料
   * @param previousPath 指定上一頁路徑條件, 未指定就是任意路徑都可以取得
   */
  store(date: any, previousPath?: string): void {
    let key = '';
    if (previousPath) {
      key = `${previousPath}-${this.currentPath}`;
    } else {
      key = `${this.none}-${this.currentPath}`;
    }
    this.state[key] = date;
  }

  /**
   * 預設取完資料便清除
   * @param clear 清除資料
   * @returns any
   */
  takeMatchPreviousPath(clear = true): any {
    if (!this.previousPath) {
      return;
    }
    return this.take(
      this.formatKey(this.previousPath, this.currentPath),
      clear
    );
  }

  /**
   * 預設取完資料便清除
   * @param clear 清除資料
   * @returns any
   */
  takeNoneCondition(clear = true): any {
    return this.take(this.formatKey(this.none, this.currentPath), clear);
  }

  private take(key: string, clear: boolean): any {
    const data = this.state[key];
    if (clear) {
      delete this.state[key];
    }
    return data;
  }

  private formatKey(previous: string, current: string): string {
    return `${previous}-${current}`;
  }
}
